import { render, staticRenderFns } from "./DurationFields.vue?vue&type=template&id=5c575600"
import script from "./DurationFields.vue?vue&type=script&lang=js"
export * from "./DurationFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports